import { Guid } from '../guid';

export class CaseNote {
	public id: string = Guid.newGuid();
	public title: string;
	public body: string;
	public pageNumber: number;
	public isPrivate: boolean;
	public documentId: string;
	public documentName: string;
	public createdById: string;
	public createdAt: string;
	public author: string;
	public isNew: boolean = false;
	public pageCount: number;
}
